// extracted by mini-css-extract-plugin
export var centerText = "_dj-8";
export var container = "_dj-0";
export var doughnutContainer = "_dj-7";
export var legend = "_dj-a";
export var legendItemColorDisplay = "_dj-b";
export var legendItemLabel = "_dj-d";
export var legendItemValue = "_dj-c";
export var lg = "_dj-5";
export var maxWidth = "_dj-9";
export var md = "_dj-4";
export var responsive = "_dj-6";
export var sm = "_dj-3";
export var xs = "_dj-2";
export var xxs = "_dj-1";